import type {
  GlossaryProposalStatus,
  KnowledgeStatus,
  KnowledgeVisibility,
} from '@sbc/domain-models/knowledge-base';

import { Badge } from '@/components/ui/badge';

// Approved is the only agent-visible state, so it gets the solid accent; draft and
// archived read as muted.
const STATUS_VARIANT: Record<KnowledgeStatus, 'default' | 'secondary' | 'outline'> = {
  approved: 'default',
  draft: 'secondary',
  archived: 'outline',
};

export function StatusBadge({ status }: { status: KnowledgeStatus }) {
  return <Badge variant={STATUS_VARIANT[status]}>{status}</Badge>;
}

export function VisibilityBadge({ visibility }: { visibility: KnowledgeVisibility }) {
  return <Badge variant={visibility === 'internal' ? 'outline' : 'secondary'}>{visibility}</Badge>;
}

const PROPOSAL_VARIANT: Record<GlossaryProposalStatus, 'default' | 'secondary' | 'outline'> = {
  pending: 'secondary',
  approved: 'default',
  rejected: 'outline',
};

export function ProposalStatusBadge({ status }: { status: GlossaryProposalStatus }) {
  return <Badge variant={PROPOSAL_VARIANT[status]}>{status}</Badge>;
}
